import { withGlobal } from "components/global/GlobalWrapper";
import BuildingUnitEdit from "./BuildingUnitEdit";
import { buildingStructuresReducers } from "components/stores/building_structures/reducers";

export default withGlobal(BuildingUnitEdit, { reducers: buildingStructuresReducers });
